export default __webpack_public_path__ + "static/media/twitter.7764a138.svg";